import React from 'react';

export default function WatchIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g
        id="watch"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="ic/ondemand_video">
          <g>
            <mask id="mask-2" fill="white">
              <path
                d="M21,3 L3,3 C1.89,3 1,3.89 1,5 L1,17 C1,18.1 1.89,19 3,19 L8,19 L8,21 L16,21 L16,19 L21,19 C22.1,19 22.99,18.1 22.99,17 L23,5 C23,3.89 22.1,3 21,3 Z M21,17 L3,17 L3,5 L21,5 L21,17 Z M16,11 L9,15 L9,7 L16,11 Z"
                id="path-1"></path>
            </mask>
            <g id="Shape" fillRule="nonzero"></g>
            <g id="Blue-/-B300" mask="url(#mask-2)" fill="#0065FF">
              <rect id="B300" x="0" y="0" width="24" height="24"></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
